
$(document).ready(function(){
    $('.slider-products').slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
        }
        },
        {
        breakpoint: 650,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            infinite: false,
            slidesToScroll: 1,
            dots: false
        }
        }
    ]
    });

    // Re-apply SASO offer badges after Slick has initialized featured product sliders
    if (typeof window.sasoAddProductBadges === 'function' && window.saso && window.saso.page_actions_data) {
      document.querySelectorAll('.slider-products .saso-badge-wrapper').forEach(function (el) {
        el.remove();
      });
      window.sasoAddProductBadges(window.saso.page_actions_data);
    }

    // Blogs ****************************

    $('.news-blogs-home').slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
            },
            {
            breakpoint: 650,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
            }
            },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
            }
            }
        ]
        });
        

    // Testimonial*********************

    $('.testimonial-slider-main').slick({
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 990,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
            },
            {
            breakpoint: 650,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            }
        ]
        });

  // Clickable banner slider (optional)
var $bannerSlider = $('.ad-banner.banner-slider');
if ($bannerSlider.length) {
    var autoplaySetting = $bannerSlider.data('autoplay');
    var autoplayEnabled = autoplaySetting === true || autoplaySetting === 'true';

    $bannerSlider.slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: autoplayEnabled,
        autoplaySpeed: 2000,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
});